import { useTenantData } from "contexts/tenant";
import { ComplianceTab } from "./ComplianceTab";
import { RecipeComplianceReportTab } from "./RecipeComplianceReportTab";

export const CompliancePage = () => {
  const { compliance_page_version: compliancePageVersion } = useTenantData();

  return compliancePageVersion === "modern" ? (
    <RecipeComplianceReportTab />
  ) : (
    <ComplianceTab />
  );
};
